import { instance } from "libs/api";

import { InventoryManagerListItem } from "../../inventory.types";
import { ApiRoutesInventory } from "./../../constants";
import { updateInventoryManagerPayload } from "./updateInventoryManager.types";

export const requestUpdateInventoryManager = async (
  body: updateInventoryManagerPayload
): Promise<InventoryManagerListItem> => {
  return await instance.put(ApiRoutesInventory.InventoryManager, body);
};
